import React, {Component} from "react";
import MaterialIcon from "../MaterialIcon";
import DatePickerRange from "../DatePicker";
import {connect} from "react-redux";

import {FormattedMessage} from 'react-intl';

class AnalyticsSecondaryMenu extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="secondary-menu">
                <div className="analytics-menu-wrapper">
                        <button className="add-graph-button" disabled={this.props.isReadOnly} onClick={() => {this.props.updateState()}}>
                            <MaterialIcon icon="add" size={24}/>
                            <span><FormattedMessage id="add new"/></span>
                        </button>
                    <DatePickerRange readOnly={this.props.isReadOnly} showGlobal={false}/>
                </div>
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        properties: state.properties
    }
}
export default connect(mapStateToProps)(AnalyticsSecondaryMenu);